export default __webpack_public_path__ + "static/media/LinkedIn.b0c895e6.png";